import { Component, OnInit } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

// Interfaces
import {
  EChannelPushStockOMSProduct,
  EProductMappingType,
  IChannelProductMappingV2,
} from '../../interfaces';

interface ICellRendererParamsChannel extends ICellRendererParams {
  mappingType :EProductMappingType;
}

@Component({
  selector: 'lum-channel-product-mapping-sku-cell-renderer',
  templateUrl: './channel-product-mapping-sku-cell-renderer.component.html',
  styleUrls: ['./channel-product-mapping-sku-cell-renderer.component.scss'],
})
export class ChannelProductMappingSkuCellRendererComponent
  implements ICellRendererAngularComp
{
  params :ICellRendererParamsChannel;
  displayLabel :string | null;

  constructor() {}

  agInit(params :ICellRendererParamsChannel) :void {
    this.params = params;
    this.initData();
  }

  refresh(params :any) :boolean {
    return false;
  }

  private initData() :void {
    const { data, value } = this.params;

    switch (this.params.mappingType) {
      case EProductMappingType.CHANNEL:
        if (data?.productOverride?.lumSku) {
          this.displayLabel = `[${data?.productOverride?.lumSku?.internalSku}] ${data?.productOverride?.lumSku?.productName}`;
          this.params.node.setDataValue(
            EChannelPushStockOMSProduct.SELLING_UNIT,
            data?.productOverride?.lumSku?.defaultSellingUnit?.name || '',
          );
        } else if (data?.lumSku) {
          this.displayLabel = `[${data?.lumSku?.internalSku}] ${data?.lumSku?.productName}`;
          this.params.node.setDataValue(
            EChannelPushStockOMSProduct.SELLING_UNIT,
            data?.lumSku?.defaultSellingUnit?.name || '',
          );
        }
        break;

      case EProductMappingType.APP_INTEGRATION_ACCOUNT:
        if (value && value?.internalSku && value?.productName) {
          this.params.node.setDataValue(
            EChannelPushStockOMSProduct.SELLING_UNIT,
            value?.defaultSellingUnit?.name || '',
          );
          this.displayLabel = `[${value?.internalSku}] ${value?.productName}`;
        } else if (data?.lumSku) {
          this.displayLabel = `[${data?.lumSku?.internalSku}] ${data?.lumSku?.productName}`;
          this.params.node.setDataValue(
            EChannelPushStockOMSProduct.SELLING_UNIT,
            data?.lumSku?.defaultSellingUnit?.name || '',
          );
        }
        break;

      default:
        break;
    }
  }
}
